const images = {
    loginBackground: require('./login-background.jpg'),
    loginCardPattern: require('./login-card-pattern.png'),
    logoStackedOrange: require('./ygt-logo-stacked-orange.png'),
    logoOrange: require('./ygt-logo-Orange.svg').default,
    logoBurgundy: require('./ygt-logo-Burgundy.svg').default,
    logoSand: require('./ygt-logo-sand.svg').default,
    logoWhite: require('./ygt-logo-White.svg').default,
    logoBlack: require('./ygt-logo-Black.svg').default,
    notFound: require('./not-found-img.svg').default,
    awardGoflLogo: require('./award-gofl-logo.png'),
    keyIndor: require('./Key-in-door.jpg'),
    golfDefault: require('./golf_default.jpg'),
    bestPrice: require('./best-price.png'),
    loyalty: require('./loyalty.png'),
};
export default images;
